<template>
  <div id="money">
     
    <!-- 条件筛选 -->
    <div class="disflexbtw">

      <el-date-picker
        v-model="para.startDate"
        @change="handleSearch"
        type="date"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        placeholder="起始日期">
      </el-date-picker>

      <el-date-picker
        v-model="para.endDate"
        @change="handleSearch"
        placeholder="截止日期"
        type="date"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd">
      </el-date-picker>

      <el-select v-model="para.customId" placeholder="客户" @change="handleSearch" clearable> 
        <el-option :label="item.chineseName" :value="item.id" v-for="item in companylist" :key="item.key"></el-option>
      </el-select>

      <el-select v-model="para.condition" placeholder="订单状态" @change="handleSearch" clearable> 
        <el-option label="未结算" value="1"></el-option>
        <el-option label="已结算" value="2"></el-option>
        <el-option label="开票" value="3"></el-option>
        <el-option label="完成" value="4"></el-option>
      </el-select>
      
      <div>
        <el-button  @click="handleSet('生成月结费报表', null)" >生成月结费报表</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          label="销售合同号">
          <template slot-scope="scope">
            <div>{{ scope.row.contractNumber }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="商品中文名">
          <template slot-scope="scope">
            <div>{{ scope.row.goodsName }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="型号">
          <template slot-scope="scope">
            <div>{{ scope.row.model }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="销售数量(净重)">
          <template slot-scope="scope">
            <div>{{ scope.row.salesQuantity }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="销售数量(毛重)">
          <template slot-scope="scope">
            <div>{{ scope.row.roughWeight }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="入库时间">
          <template slot-scope="scope">
            <div>{{ formatime(scope.row.entryTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="出库时间">
          <template slot-scope="scope">
            <div>{{ formatime(scope.row.deliveryTime) }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="托盘数量">
          <template slot-scope="scope">
            <div>{{ scope.row.trayCount }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <div>{{ formatstatus(scope.row.payStatus) }}</div>
          </template>
        </el-table-column>
        <!-- 1，未结算，2已结算3开票4收款 -->
        <el-table-column
          width="320"
          label="操作选项">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleSet('查看', scope.row)">查看</el-button>
            <el-button v-if="scope.row.payStatus === 1" size="mini" type="warning" @click="handleSet('结算', scope.row)">结算</el-button>
            <el-button v-if="scope.row.payStatus === 2" size="mini" type="info" @click="handleSet('编辑', scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch('分页', value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
        <div class="comond_btn">
          <el-button type="success" @click="handleSet('开票', null)" >开票</el-button>
          <el-button type="danger" @click="handleSet('收款', null)" >收款</el-button>
        </div>
      </div>
    </template>

    <!-- 弹框 -->
    <el-dialog
      :title="dialogPara.title"
      :visible.sync="dialogPara.isShowDialog"
      :width="dialogPara.width"
      center
      >
      <el-form :model="form">

         <template v-if="currentStatus === '生成月结费报表'">
          <div class="prohead">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="公司">
              <el-select v-model="form.companyId" placeholder="请选择" clearable> 
                <el-option :label="item.chineseName" :value="item.id" v-for="item in companylist" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- <div class="prohead">
            <el-form-item label="增值税税率">
              <el-select v-model="form.taxRate" placeholder="请选择" @focus="postdictionariesqueryDictionaryData(7)">
                <el-option
                  v-for="item in taxRateList"
                  :key="item.key"
                  :label="item.dictDataValue"
                  :value="item.dictDataValue">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

           <div class="prohead">
            <el-form-item label="关税税率">
              <el-select v-model="form.tariffRate" placeholder="请选择" @focus="postdictionariesqueryDictionaryData(8)">
                <el-option
                  v-for="item in tariffRateList"
                  :key="item.key"
                  :label="item.dictDataValue"
                  :value="item.dictDataValue">
                </el-option>
              </el-select>
            </el-form-item>
           </div> -->

        </template>
        <!-- 查看 -->
        <template v-if="currentStatus === '查看'">

          <template>

            <div class="disflexbtw">
              <el-form-item label="销售合同号">{{ form.contractNumber }}</el-form-item>
              <el-form-item label="型号">{{ form.model }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售净重">{{ form.salesQuantity }}</el-form-item>
              <el-form-item label="销售毛重">{{ form.roughWeight }}</el-form-item>
            </div>

            <div class="disflexbtw" v-for="item in form.batchs" :key="item.key">
              <el-form-item label="批号">{{ item.lotNum }}</el-form-item>
              <el-form-item label="批号净重">{{ item.salesVolume }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="入库时间">{{ formatime(form.entryTime) }}</el-form-item>
              <el-form-item label="出库时间">{{ formatime(form.deliveryTime) }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="托盘数量">{{ form.trayCount }}</el-form-item>
            </div>

          </template>
          
          <template v-if="form.payStatus !== 1">

            <div class="disflexbtw">
              <el-form-item label="仓储费">{{ form.settled.warehouseTotal }}</el-form-item>
              <el-form-item label="转运费(仓库)">{{ form.settled.movePrice }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="入库费">{{ form.settled.storageTotal }}</el-form-item>
              <el-form-item label="出库费">{{ form.settled.depotTotal }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="贴标费">{{ form.settled.labelCount }}</el-form-item>
              <el-form-item label="缠绕费">{{ form.settled.filmWindingTotal }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="运费">{{ form.settled.freight * form.roughWeight }}</el-form-item>
              <el-form-item label="保险费">{{ form.settled.insuranceTotal }}</el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="小计">{{ form.settled.total }}</el-form-item>
              <el-form-item label="客户">{{ form.settled.address }}</el-form-item>
            </div>

          </template>
            
        </template>

        <!-- 结算 -->
        <template v-if="currentStatus === '结算' || currentStatus === '编辑'">

          <el-form-item label="仓储费" class="settle">
            <div class="info"><span>托盘数</span> x <span>天数</span> x <span>单价</span> x <span>托盘面积</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.trayCount" placeholder="托盘数" :disabled="true"/>
            x
            <el-input size="mini" v-model="form.stockDay" placeholder="天数" :disabled="true"/>
            x
            <el-input size="mini" v-model="pbment.warehouse" placeholder="单价" :disabled="true"/>
            x
            <el-input size="mini" v-model="form.trayArea" placeholder="托盘面积"/> 
            =
            <el-input size="mini" v-model="warehouseTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="入库费" class="settle">
            <div class="info"><span>托盘数</span> x <span>入库费单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.trayCount" placeholder="托盘数" :disabled="true"/>
            x
            <el-input size="mini" v-model="pbment.storage" placeholder="入库费单价" :disabled="true"/>
            =
            <el-input size="mini" v-model="storageTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="出库费" class="settle">
            <div class="info"><span>托盘数</span> x <span>出库费单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.trayCount" placeholder="托盘数" :disabled="true"/>
            x
            <el-input size="mini" v-model="pbment.depot" placeholder="出库费单价" :disabled="true"/>
            =
            <el-input size="mini" v-model="depotTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="转运费(仓库)" class="settle">
            <div class="info"><span>次数</span> x <span>转运费单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.moveCount" placeholder="次数"/> 
            x
            <el-select v-model="form.movePrice" placeholder="请选择" size="mini"> 
              <el-option :label="item.dictDataValue" :value="item.dictDataValue" v-for="item in movePricetList" :key="item.key"></el-option>
              <!-- <el-option label="500" value="500"></el-option>
              <el-option label="800" value="800"></el-option> -->
            </el-select>
            =
            <el-input size="mini" v-model="moveTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="贴标费" class="settle">
            <div class="info"><span>包数</span> x <span>贴标费单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.labelCount" placeholder="包数" />
            x
            <el-input size="mini" v-model="pbment.label" placeholder="贴标费单价" :disabled="true"/>
            =
            <el-input size="mini" v-model="labelTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>
          
          <el-form-item label="缠绕膜费" class="settle">
            <div class="info"><span>打托数</span> x <span>缠绕膜单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.filmWindingCount" placeholder="打托数"/>
            x
            <el-input size="mini" v-model="pbment.filmWinding" placeholder="缠绕膜单价" :disabled="true"/>
            =
            <el-input size="mini" v-model="filmWindingTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>
  
          <el-form-item label="运费" class="settle">
            <div class="info"><span>毛重</span> x <span>运费单价</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.roughWeight" placeholder="毛重" :disabled="true"/>
            x
            <el-select v-model="form.freight" placeholder="请选择" size="mini">
              <el-option :label="item.dictDataValue" :value="item.dictDataValue" v-for="item in freightList" :key="item.key"></el-option>
              <!-- <el-option label="1.25" value="1.25"></el-option>
              <el-option label="0.99" value="0.99"></el-option>
              <el-option label="0.5" value="0.5"></el-option>
              <el-option label="0" value="0"></el-option> -->
            </el-select>
            =
            <el-input size="mini" v-model="freightTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="保险费" class="settle">
            <div class="info"><span>净重</span> x <span>销售单价</span> x <span>保险费率</span> = <span>总价</span></div>
            <el-input size="mini" v-model="form.salesQuantity" placeholder="净重" :disabled="true"/>
            x
            <el-input size="mini" v-model="form.unitCost" placeholder="销售单价" :disabled="true"/>
            x
            <el-input size="mini" v-model="pbment.insurancePremium" placeholder="保险费率" :disabled="true"/>
            =
            <el-input size="mini" v-model="insurancePremiumTotal" placeholder="总价" :disabled="true"/>
          </el-form-item>

          <el-form-item label="其他费用">
            <el-input  v-model="form.otherFee" placeholder="其他费用"/>
            
          </el-form-item>
           <el-form-item label="其他费用" style="display:none;">
            <el-input  v-model="otherPrice" placeholder="其他费用"/>
          </el-form-item>
          <el-form-item label="其他费用说明">
            <el-input  v-model="form.otherFeeRemark" placeholder="其他费用说明"/>
          </el-form-item>
          <el-form-item label="小计不含税">
            <el-input  v-model="ltotal" placeholder="小计不含税" :disabled="true"/>
          </el-form-item>
          <el-form-item label="到货地址">
            <el-input  v-model="form.address" placeholder="到货地址"/>
          </el-form-item>

        </template>

        <!-- 开票 -->
        <template v-if="currentStatus === '开票' || currentStatus === '收款'">

          <div class="disflexbtw">
            <el-date-picker
              v-model="para.year"
              type="year"
              @change="handleSearchpre"
              value-format="yyyy"
              placeholder="选择年">
            </el-date-picker>

            <el-select v-model="para.month" placeholder="选择月" @change="handleSearchpre"> 
              <el-option :label="item" :value="item" v-for="item in 12" :key="item.key"></el-option>
            </el-select>
          </div>
          
          <el-form-item label="客户名称">
            <el-input  v-model="form.customName" placeholder="客户名称" :disabled="true"/>
          </el-form-item>

          <el-form-item label="总金额">
            <el-input  v-model="form.totalMount" placeholder="总金额" :disabled="true">
              <el-button slot="append">￥</el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="开票税率">
            <el-select v-model="form.taxRate" placeholder="请选择" @change="handleChangeCount">
              <el-option :label="item.dictDataName" :value="item.id" v-for="item in rateList" :key="item.key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="总金额">
            <el-input  v-model="form.totalMountTax" placeholder="总金额(含税)" :disabled="true">
              <el-button slot="append">￥</el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="发票上传" v-if="currentStatus === '开票'">
            <el-upload
              class="upload-demo"
              :data="qiniu"
              :limit="1"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="fileList.invoice"
              :before-upload="(file) => {return handleBeforeUpload(file, 'invoice')}"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'invoice') }"
              :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'invoice') }"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          
          <el-form-item label="发票下载" v-if="currentStatus === '收款'">
            <el-button type="primary" size="mini" @click="downloadpdf(form.invoice)" >预览下载</el-button>
          </el-form-item>

          <el-form-item label="备注">
            <el-input  v-model="form.remark" placeholder="备注"/>
          </el-form-item>

          <el-form-item label="收款日期" v-if="currentStatus === '收款'">
            <el-date-picker
              v-model="form.receiveDate"
              @change="handleSearch"
              placeholder="截止日期"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </template>

      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
     </el-dialog>

  </div>
</template>

<script>
import { 
  settlePriceorderManagerList, qiniugetDown, dictionariesqueryDictionaryData,
  settlementgetLast, settlePricedoSettle, settlePricegetSettle,
  settlePriceupdateSettle, settlemonthpreInvoice, settlePricegetDetail,
  findAll, settlemonthdoInvoice, qiniuupload,
  excelgetExcelExchangeRate,
  
  settlemonthlist, settlemonthreceive } from "../../api"
import utils from "../../../public/utils"
import moment from 'moment'
export default {
  data () {
    return {
      list: [],
      para: { //  查询条件
        status: '', //  状态
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
        width: '50%',
      },
      form: {},
      pbment: {}, //  公共结算信息
      total: 0,
      currentStatus: '',
      rateList: [], //  税率列表
      companylist: [], //  采购手列表
      qiniu: { //  七牛上传
        token: '',
        key: '',
        uploadUrl: '', //  上传地址前缀
      },
      fileList: { //  文件存储
        invoice: [], //  发票
      },
      movePricetList: [], //  转运费
      freightList: [], //  运费
      taxRateList: [],
      tariffRateList: [],
    }
  },
  mounted() {
    this.getfindAll()
    this.getsettlePriceorderManagerList()
  },
  computed: {
    warehouseTotal () { //  仓储总计
      return this.form.trayCount * this.form.stockDay * this.pbment.warehouse * this.form.trayArea
    },
    storageTotal () { //  入库费总计
      return this.form.trayCount * this.pbment.storage
    },
    depotTotal () { //  出库费总计
      return this.form.trayCount * this.pbment.depot
    },
    moveTotal () { //  转运费总计
      return this.form.moveCount * this.form.movePrice
    },
    labelTotal () { //  贴标费总计
      return this.form.labelCount * this.pbment.label
    },
    filmWindingTotal () { //  缠绕费总计
      return this.form.filmWindingCount * this.pbment.filmWinding
    },
    freightTotal () { //  运费总计
      return this.form.roughWeight * this.form.freight
    },
    insurancePremiumTotal () { //  保险费
      return this.form.salesQuantity * this.form.unitCost * this.pbment.insurancePremium
    },
    otherPrice () {
      return 1 * this.form.otherFee
    },
    ltotal () {
      let num  = this.warehouseTotal + this.storageTotal + this.depotTotal +
      this.moveTotal + this.labelTotal + this.filmWindingTotal +
      this.freightTotal + this.insurancePremiumTotal + this.otherPrice
      return num.toFixed(2)
    }
    
  },
  methods: {
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-sea-transportation')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.qiniu.uploadUrl = res.data.url
      })
    },
    postdictionariesqueryDictionaryData (value) { //  查询增值税与关税
      let para = new URLSearchParams(
        {
          dictionaryId: value
        }
      )
      dictionariesqueryDictionaryData(para).then(res => {
        console.log(res)
        switch (value) {
          case 7: //  增值税
            this.taxRateList = res.data
            break
          case 8: //  关税
            this.tariffRateList = res.data
            break
        }
      })
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let res = w.match(/http/g)
      if (res === null) {
        this.$message.error('该链接无效')
      } else {
        let para = new URLSearchParams()
        para.append('baseUrl', w)
        qiniugetDown(para).then(data => {
          console.log(data.data)
          window.open(data.data)
        })
      }
    },
    handleSet (type, val) {
      console.log(type, val)
      this.currentStatus = type
      this.dialogPara.title = type
       switch (type) {
        case '查看':
          this.getsettlePricegetDetail(val.id)
          this.dialogPara.width = '50%'
          this.dialogPara.isShowDialog = true
          break
        case '结算':
          this.form = {}
          this.pbment = {}
          this.form = val
          this.getsettlementgetLast()
          this.getrate(3)
          this.getrate(4)
          this.dialogPara.width = '50%'
          this.dialogPara.isShowDialog = true
          break
        case '编辑':
          this.getsettlePricegetSettle(val.id)
          this.getrate(3)
          this.getrate(4)
          this.dialogPara.width = '50%'
          this.dialogPara.isShowDialog = true
          break
        case '开票':
          this.getrate(2) //  税率
          this.getToken()
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
        case '生成月结费报表':
          this.dialogPara.width = '30%'
          this.form = {}
          this.dialogPara.isShowDialog = true
          break
        case '收款':
          //  1. 先查询未收款列表拿到开票id
          //  2. 拿开票id去查询详情进行收款
          
          this.getrate(2) //  税率
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
       }
    },
    handleSucess () {
      switch (this.currentStatus) {
        case '查看':
          this.dialogPara.isShowDialog = false
          break
        case '结算':
          this.postsettlePricedoSettle()
          this.dialogPara.isShowDialog = false
          break
        case '编辑':
          this.postsettlePriceupdateSettle()
          this.dialogPara.isShowDialog = false
          break
        case '开票':
          this.postsettlemonthdoInvoice()
          this.dialogPara.isShowDialog = false
          break
        case '收款':
          this.postsettlemonthreceive()
          this.dialogPara.isShowDialog = false
          break
        case '生成月结费报表':
          this.getexcelgetExcelExchangeRate()
          break
      }
    },
    getexcelgetExcelExchangeRate () {
      let para = new URLSearchParams(this.form)
      let responseType = {
        responseType: 'blob'
      }
      excelgetExcelExchangeRate(para, responseType).then(res => {
        if (res > 2) {
          this.$message.error('请求失败')
        } else {
          console.log(res)
          // type 为需要导出的文件类型，此处为xls表格类型
          const blob = new Blob( [res], {type: 'application/vnd.ms-excel'} )
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob)
          // 创建a标签并为其添加属性
          let downloadLink = document.createElement('a')
          downloadLink.href = downloadHref
          downloadLink.download = 'xxx.xlsx'
          // 触发点击事件执行下载
          downloadLink.click()
        }
      })
    },
    handleChangeCount (val) {
      switch (val) {
        case 3:
          this.form.totalMountTax = this.form.totalMount + this.form.totalMount * 0.03
          break
        case 4:
          this.form.totalMountTax = this.form.totalMount + this.form.totalMount * 0.16
          break
      }
    },
    handleBeforeUpload (file, type) { //  上传之前
      this.qiniu.key = ``+ type +`${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, type) { //  上传成功之后
      this.form[type] =  this.qiniu.uploadUrl + response.key
    
      this.fileList[type].push({ //  显示文件
        name: response.key,
        url: this.qiniu.uploadUrl + response.key
      })
    },
    handleOnRemove (file, fileList, type) { //  删除
      this.fileList[type] = []
    },
    handleSearchpre (val) { //  查询开票信息
      console.log(val)
      if (this.currentStatus === '收款') {
        let para = {
          status: 0,
          pageIndex: 1,
          pageSize: 10,
          customId: this.para.customId,
          invoiceDate: this.para.year + '-' + this.para.month
        }
        this.getsettlemonthlist(para)
      } else {
        this.getsettlemonthpreInvoice()
      }
    },
    handleSearch (type, val)  {
      console.log(type, val)
      this.para.pageIndex = 1
      if (val) {
        this.para.pageIndex = val
      }
      this.getsettlePriceorderManagerList()
    },
    postsettlemonthreceive () { //  收款
      let para = new URLSearchParams(this.form)
      settlemonthreceive(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getsettlePriceorderManagerList()
          this.$message.success(msg)
        } else {
          this.$message.error(msg)
        }
      })
    },
    postsettlemonthdoInvoice () { //  开票
      this.form.year = this.para.year
      this.form.month = this.para.month
      let para = new URLSearchParams(this.form)
      settlemonthdoInvoice(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getsettlePriceorderManagerList()
          this.$message.success(msg)
        } else {
          this.$message.error(msg)
        }
      })
    },
    postsettlePriceupdateSettle () { //  编辑
      let para = new URLSearchParams(this.form)
      settlePriceupdateSettle(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getsettlePriceorderManagerList()
          this.$message.success(msg)
        } else {
          this.$message.error(msg)
        }
      })
    },
    postsettlePricedoSettle () { //  结算
      let para = new URLSearchParams(this.form)
      settlePricedoSettle(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getsettlePriceorderManagerList()
          this.$message.success(msg)
        } else {
          this.$message.error(msg)
        }
      })
    },
    
    getsettlePricegetDetail (id) { //  所有的小查看
      let para = {
        id: id
      }
      settlePricegetDetail(para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        this.form = data
      })
    },
    getsettlemonthpreInvoice () { //  开票详情
      console.log(this.para)
      settlemonthpreInvoice(this.para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        if (code === 10000) {
          this.form = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    getsettlePricegetSettle (id) { //  编辑详情
      let para = {
        id: id
      }
      settlePricegetSettle(para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        this.form = data
        this.pbment = data.settlement
      })
    },
    getsettlementgetLast () { //  公共结算信息
      settlementgetLast().then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        this.pbment = data
        if (data) {
          this.form.settlementId = data.id
        }
      })
    },
    getsettlePriceorderManagerList () { //  列表查询
      settlePriceorderManagerList(this.para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        this.list = data.rows
        this.total = data.total
      })
    },
    getsettlemonthlist (para) { //  结算列表查询
      settlemonthlist(para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        if (data) {
          this.form = data.rows[0]
        } else {
          this.$message.error('不存在该时间数据')
          this.form = {}
        }
        // this.total = data.total
      })
    },
    getfindAll () {
      let para = {
        status: 1,
        typeId: 1,
      }
      findAll(para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        if (code === 10000) {
          this.companylist = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    getrate (did) { //  查询税率列表
      let para = new URLSearchParams({
        'dictionaryId': did
      })
      dictionariesqueryDictionaryData(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        switch(did) {
          case 2:
            this.rateList = data
            break
          case 3:
            this.movePricetList = data
            break
          case 4:
            this.freightList = data
            break
        }
        
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    old_downloadpdf (w) { // 下载
      console.log(w)
      let res = w.match(/http/g)
      if (res === null) {
        this.$message.error('该链接无效')
      } else {
        let para = new URLSearchParams()
        para.append('baseUrl', w)
        qiniugetDown(para).then(data => {
          console.log(data.data)
          window.open(data.data)
        })
      }
    },
    formatstatus (s) {// 1-未结算，2-已结算 3-开票  4-收款
      
      switch (s) {
        case 1:
          return '未结算'
        case 2:
          return '已结算'
        case 3:
          return '已开票'
        case 4:
          return '已收款'
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
#money
  .settle
    .el-form-item__content
      line-height 2em
    .info
      span
        display inline-block
        width 80px
        // text-align center
    .el-form-item__content
      .el-input__inner
        padding 0 4px
      .el-input
        width 80px
  .disflexbtw
    display flex
    justify-content space-between
  .el-form-item
    display flex
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
      button
        // background-color #67c23a
        // border 1px solid #67c23a
        // color #fff

</style>
